import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../toolkit/uicomponent';
import { BaseContext } from '../../utils/basecontext';
import { UIComponentView } from '../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../toolkit/uicomponentcss';
import { MainWrapperViewImpl } from './mainwrapperview';
import { MainWrapperCSSStyleImpl } from './mainwrappercss';
import { RoutingFeatures } from './navigation/routingfeature';
import { LanguageConst } from '../../utils/resources/languageconst';

export interface ChildComponentProps extends UIComponentProps
{
    routeNextFeature(routingFeature: RoutingFeatures, isRedirectionRequired: boolean): void;
}

export interface MainWrapperComponentProps extends UIComponentProps
{
    childComponent: JSX.Element;
    onCategorySelected(categoryDto: string): void;
    routeNextFeature(routingFeature: RoutingFeatures, isRedirectionRequired: boolean): void;
}

export interface MainWrapperComponentHandler extends UIComponentHandler
{
    onLogoClicked(): void;
    onSignInClicked():void;
    onFaqClicked(): void;
    onTermsandConditionClicked():void;
    onSalathiClicked(): void;
    onDoItYourselfClicked(): void;
    onMyAccountOptionClicked(routingFeature: string): void;
    onLanguageChange(languageSelected: LanguageConst): void;
    onMTNHomeClicked(): void;
}

export class MainWrapperComponent<T extends MainWrapperComponentProps, S extends UIComponentState> 
        extends UIComponentImpl<T, S, UIDataModel> implements MainWrapperComponentHandler
{
    constructor(props: T)
    {
        super(props);

        // console.log("-----IsLoggedIn bn: " + JSON.stringify(this.props.context.getUserContext().getIsLoggedIn()));
        // if(this.props.context.getUserContext().getIsLoggedIn())
        // {
        //     this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
        // }
    }

    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        console.log("main wrapper componentWillMount() invoked");
        window.scrollTo(0,0);
        console.log("-----channelid from context: " + this.props.context.getUserContext().getChannelId());

       
        if(this.props.context.getUserContext().getChannelId() === "" || 
        this.props.context.getUserContext().getChannelId() === undefined)
        {
            this.props.context.getUserContext().setChannelId(window.navigator.userAgent.startsWith("Ayoba")?this.props.context.getProperty().getAyobaChannelId():   
                 this.props.context.getProperty().getChannelId());

            this.props.context.setUserContext(this.props.context.getUserContext()); 
        }

    }
    
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MainWrapperViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MainWrapperCSSStyleImpl(applicationContext);
    }

    onLanguageChange(languageSelected: LanguageConst): void 
    {
        this.props.context.getUserContext().setLanguage(languageSelected);
        this.props.context.setUserContext(this.props.context.getUserContext());
        
        this.props.routeNextFeature(RoutingFeatures.HOME, false);
        window.location.reload();
    }

    onLogoClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.HOME, false);
        // if(this.getContext().getUserContext().getIsLoggedIn())
        // {
        // }
    }

    onSignInClicked():void
    {
        this.props.routeNextFeature(RoutingFeatures.LOGIN,true);
    }
    onMyAccountOptionClicked(routingFeature: string): void 
    {   
        this.props.routeNextFeature(routingFeature, false);
    }
    onTermsandConditionClicked(): void {
        this.props.routeNextFeature(RoutingFeatures.TERMS_AND_CONDITION, false);

    }
    onFaqClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.FAQ, false);
    }

    onSalathiClicked(): void 
    {
        // this.props.routeNextFeature(RoutingFeatures.SALATI, false);
    }

    onDoItYourselfClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.DO_IT_YOURSELF, false);
    }

    onMTNHomeClicked(): void
    {
        this.props.routeNextFeature(RoutingFeatures.HOME, false);
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/mainwrappercomponent.tsx